const initialState = {
  "recorder-type": "",
  vehicle: "",
  track: "",
  "departure-airport": "",
  "arrival-airport": "",
  "from-date": "",
  "to-date": "",
};

export default function trackFilter(state = initialState, action) {
  switch (action.type) {
    case 'CHANGE_TRACK_FILTER_ITEM':
      return { ...state, ...action.payload }
    case 'APPLY_TRACK_FILTER':
      return state
    default:
      return state;
  }
}
